import React from 'react'
import { Checkbox } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const BaseCheckbox = withStyles((theme) => ({
  root: {
    color: theme.palette.common.digigreen,
    '&$checked': {
      color: theme.palette.common.digigreen,
    },
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />)
export default BaseCheckbox
